import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <div className="page" style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem' }}>
      <button onClick={() => navigate('/')} className="btn btn-ghost" style={{ marginBottom: '2rem' }}>
        <ArrowLeft size={20} style={{ marginRight: '0.5rem' }} /> Back to Home
      </button>

      <h1 style={{ fontSize: '2.5rem', marginBottom: '2rem' }}>Privacy Policy</h1>
      
      <div style={{ fontSize: '1rem', lineHeight: 1.8, color: '#D1D5DB' }}>
        <p style={{ marginBottom: '1.5rem' }}><strong>Last Updated:</strong> January 2025</p>
        
        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>1. Information We Collect</h2>
        <p style={{ marginBottom: '1rem' }}>We collect information you provide when creating an account and using Astrowins services:</p>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Personal details (name, email, birth date, time, place)</li>
          <li>Family information (parents' names, siblings count)</li>
          <li>Analysis results and readings</li>
          <li>Uploaded images (for Vastu analysis)</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>2. How We Use Your Information</h2>
        <ul style={{ marginBottom: '1.5rem', paddingLeft: '2rem' }}>
          <li>Generate personalized numerology, vastu, and astrology analyses</li>
          <li>Provide AI-powered insights and predictions</li>
          <li>Store your reading history for future reference</li>
          <li>Improve our services and algorithms</li>
        </ul>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>3. Data Security</h2>
        <p style={{ marginBottom: '1rem' }}>We use industry-standard security measures to protect your data. Your personal information is encrypted and stored securely in our database.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>4. Data Sharing</h2>
        <p style={{ marginBottom: '1rem' }}>We do NOT sell or share your personal information with third parties. Your astrological data is private and confidential.</p>

        <h2 style={{ fontSize: '1.75rem', marginTop: '2rem', marginBottom: '1rem' }}>5. Contact Us</h2>
        <p>For privacy concerns, contact us at: <a href="mailto:hello@astrowins.in" style={{ color: '#00D9FF' }}>hello@astrowins.in</a></p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;